const formatterCache = /* @__PURE__ */new Map();
function cacheKey(locale, options) {
  return `${JSON.stringify(locale ?? null)}|${JSON.stringify(options)}`;
}
export function getDateTimeFormat(locale, options) {
  const key = cacheKey(locale, options);
  const cached = formatterCache.get(key);
  if (cached) {
    return cached;
  }
  const formatter = new Intl.DateTimeFormat(locale, options);
  formatterCache.set(key, formatter);
  return formatter;
}
export function formatDisplayDate(date, locale, style = "medium") {
  return getDateTimeFormat(locale, {
    dateStyle: style
  }).format(date);
}
export function formatMonthYear(date, locale) {
  return getDateTimeFormat(locale, {
    month: "long",
    year: "numeric"
  }).format(date);
}
export function getWeekdayLabels(locale, weekStartsOn) {
  const formatter = getDateTimeFormat(locale, {
    weekday: "narrow"
  });
  const labels = [];
  for (let offset = 0; offset < 7; offset += 1) {
    const dayIndex = (weekStartsOn + offset) % 7;
    const reference = new Date(2024, 0, dayIndex === 0 ? 7 : dayIndex);
    labels.push(formatter.format(reference));
  }
  return labels;
}
export function formatDateRange(start, end, locale, style = "medium") {
  const formatter = getDateTimeFormat(locale, {
    dateStyle: style
  });
  if (typeof formatter.formatRange === "function") {
    return formatter.formatRange(start, end);
  }
  return `${formatter.format(start)} \u2013 ${formatter.format(end)}`;
}
export function formatTodayLabel(locale) {
  return new Intl.RelativeTimeFormat(locale, {
    numeric: "auto"
  }).format(0, "day");
}